module.exports = __webpack_public_path__ + "static/img/j-5.f8cf23ee.png";